export interface CheckboxProps {
  uiId: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  /** 有值時渲染文字並用 htmlFor 綁到 input，點文字也能切換；沒有值時由呼叫端自行做關聯。 */
  label?: string;
  disabled?: boolean;
  name?: string;
}

/**
 * 勾選方塊。
 *
 * ponytail: 用原生 `<input type="checkbox">` ＋ `accent-color`，不還原原系統的 iCheck plugin。
 * 原系統靠 `.icheckbox_square-green`（custom.css:3-32）把真正的 input 藏起來，改用一張
 * 240x24 的 sprite 圖（green.png，另有 @2x）疊出勾選外觀。§3.2 禁止載入外部資產，
 * 所以雛形改用原生控制項並把顏色調成同一支綠（token --color-brand #637d4c）。
 * 【雛形值待實機校準】：iCheck 的方塊是 22x22px（custom.css:10-11），這裡照抄了 22px，
 * 但原生 checkbox 的內部繪製與 sprite 圖不會一樣，等實機截圖再校。
 *
 * DOM id 直接用 uiId：§10.3 保證同一畫面內 uiId 唯一，正好可以拿來做 label 關聯，
 * 不必再多開一個 id prop 讓呼叫端維護兩組識別字。
 */
export function Checkbox({
  uiId,
  checked,
  onChange,
  label,
  disabled = false,
  name,
}: CheckboxProps) {
  const input = (
    <input
      type="checkbox"
      id={uiId}
      data-ui-id={uiId}
      name={name}
      className="size-[22px] shrink-0 accent-brand disabled:cursor-not-allowed"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
  );

  if (label === undefined) {
    return input;
  }

  return (
    <label htmlFor={uiId} className="inline-flex cursor-pointer items-center gap-2 text-ink">
      {input}
      <span>{label}</span>
    </label>
  );
}
